import * as React from 'react';
import { createContext, useContext } from 'react';

import { impressAiSearchOnLOHP } from 'bundles/search-common/utils/experimentUtils';
import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';

// Lazy-loaded to avoid pulling in CoachChat → SSELink → ApolloLink at module-load
// time, which breaks unrelated test suites that transitively import this provider.
const CoachChatContainer = React.lazy(
  () => import('bundles/search-common/components/experiments/aiSearchOnLohp/CoachChatContainer')
);

export type AiSearchExperimentContextType = {
  isAiSearchEnabled: boolean;
  isVariant1: boolean;
  isVariant2: boolean;
};

const AiSearchExperimentContext = createContext<AiSearchExperimentContextType>({
  isAiSearchEnabled: false,
  isVariant1: false,
  isVariant2: false,
});

export const useAiSearchExperimentData = () => {
  return useContext(AiSearchExperimentContext);
};

function AiSearchExperimentProvider({ children }: React.PropsWithChildren) {
  const impressedAiSearchVariant = impressAiSearchOnLOHP();
  const isAiSearchEnabled = impressedAiSearchVariant !== 'control';
  const isVariant1 = impressedAiSearchVariant === 'variant1';
  const isVariant2 = impressedAiSearchVariant === 'variant2';

  return (
    <AiSearchExperimentContext.Provider value={{ isAiSearchEnabled, isVariant1, isVariant2 }}>
      {isAiSearchEnabled ? (
        <CoachStateProvider>
          {children}
          <React.Suspense fallback={null}>
            <CoachChatContainer />
          </React.Suspense>
        </CoachStateProvider>
      ) : (
        children
      )}
    </AiSearchExperimentContext.Provider>
  );
}

export default AiSearchExperimentProvider;
